/** @jsx builderX.jsx */

import { builderX, Sprite, Image, Text, Button } from '@gongxigames/framework/core/fragments/BuilderX';

export default (
    <Sprite name='bottomBar_portrait'>
        <Image position={[0, 2071]} scale={[1.001, 1]} /* Fix: ensures bottom bar stretches fully to the right edge in Portrait mode */ name='bg' src='bg_ui_wide_pm' />
        <Sprite position={[592, 2070]} name='winPanel'>
            <Image position={[-12, -40]} name='bg' src='win_ui_wide_pm' />
            <Text
                position={[88, 40]}
                style={{
                    fontFamily: 'PF DinDisplay Pro',
                    fontSize: 140,
                    fontStyle: 'normal',
                    fill: '#FFFFFF',
                    align: 'center',
                    fontWeight: 'bold'
                }}
                maxWidth={800}
                name='fieldText'
                localeTextID=''
                text='$24000.00'
            />
            <Text
                position={[386, 202]}
                style={{
                    fontFamily: 'PF DinDisplay Pro',
                    fontSize: 55,
                    fontStyle: 'normal',
                    fill: '#FFFFFF',
                    align: 'center',
                    fontWeight: 'bold'
                }}
                maxWidth={203}
                name='label'
                localeTextID=''
                text='WIN'
            />
        </Sprite>
        <Button position={[1771, 217]} hitArea={{ width: 325, x: 14, y: 14, type: 'rectangle', height: 194 }} name='menuButton'>
            <Sprite>
                <Image src='menu_button_normal' />
            </Sprite>
            <Sprite>
                <Image src='menu_button_normal' />
            </Sprite>
            <Sprite>
                <Image src='menu_button_pressed' />
            </Sprite>
            <Sprite>
                <Image src='menu_button_disabled' />
            </Sprite>
        </Button>
        <Button position={[36, 217]} hitArea={{ width: 325, x: 14, y: 14, type: 'rectangle', height: 194 }} name='homeButton'>
            <Sprite>
                <Image src='home_button_normal' />
            </Sprite>
            <Sprite>
                <Image src='home_button_normal' />
            </Sprite>
            <Sprite>
                <Image src='home_button_pressed' />
            </Sprite>
            <Sprite>
                <Image src='home_button_disabled' />
            </Sprite>
        </Button>
        <Button position={[237, 2894]} hitArea={{ width: 335, x: 14, y: 14, type: 'rectangle', height: 200 }} name='betButton'>
            <Sprite>
                <Image src='bet_button_normal' />
            </Sprite>
            <Sprite>
                <Image src='bet_button_normal' />
            </Sprite>
            <Sprite>
                <Image src='bet_button_pressed' />
            </Sprite>
            <Sprite>
                <Image src='bet_button_disabled' />
            </Sprite>
        </Button>
        <Text
            position={[1126, 2442]}
            style={{
                fontFamily: 'PF DinDisplay Pro',
                fontSize: 70,
                fontStyle: 'normal',
                fill: '#06BF00',
                align: 'center',
                fontWeight: 'bold'
            }}
            maxWidth={1000}
            name='tickerRight'
            localeTextID=''
            text='PRESS SPIN BUTTON'
        />
        <Text
            position={[1126, 2442]}
            style={{
                fontFamily: 'PF DinDisplay Pro',
                fontSize: 90,
                fontStyle: 'normal',
                fill: '#FFFFFF',
                align: 'center',
                fontWeight: 'bold'
            }}
            maxWidth={1000}
            name='pointsBalance'
            localeTextID=''
            text=''
        />
        <Text
            position={[40, 2442]}
            style={{
                fontFamily: 'PF DinDisplay Pro',
                fontSize: 70,
                fontStyle: 'normal',
                fill: '#D1D1D1',
                align: 'center',
                fontWeight: 'bold'
            }}
            maxWidth={1000}
            name='tickerLeft'
            localeTextID=''
            text='40 LINES BET MULTIPLIER'
        />
        <Sprite position={[19, 2134]} name='totalBetPanel'>
            <Text
                style={{
                    fontFamily: 'PF DinDisplay Pro',
                    fontSize: 100,
                    fontStyle: 'normal',
                    fill: '#FFFFFF',
                    align: 'center',
                    fontWeight: 'bold'
                }}
                maxWidth={600}
                name='fieldText'
                localeTextID=''
                text='$100.000'
            />
            <Text
                position={[19, 135]}
                style={{
                    fontFamily: 'PF DinDisplay Pro',
                    fontSize: 60,
                    fontStyle: 'normal',
                    fill: '#FFD200',
                    align: 'center',
                    fontWeight: 'bold'
                }}
                maxWidth={560}
                name='label'
                localeTextID=''
                text='TOTAL BET'
            />
        </Sprite>
        <Sprite position={[1545, 2134]} name='balancePanel'>
            <Text
                position={[18, 135]}
                style={{
                    fontFamily: 'PF DinDisplay Pro',
                    fontSize: 60,
                    fontStyle: 'normal',
                    fill: '#FFD200',
                    align: 'center',
                    fontWeight: 'bold'
                }}
                maxWidth={556}
                name='label'
                localeTextID=''
                text='BALANCE'
            />
            <Text
                style={{
                    fontFamily: 'PF DinDisplay Pro',
                    fontSize: 100,
                    fontStyle: 'normal',
                    fill: '#FFFFFF',
                    align: 'center',
                    fontWeight: 'bold'
                }}
                maxWidth={600}
                name='fieldText'
                localeTextID=''
                text='$1000.000'
            />
        </Sprite>
        <Button position={[1573, 2893]} hitArea={{ width: 325, x: 14, y: 12, type: 'rectangle', height: 196 }} name='turboButtonOn'>
            <Sprite>
                <Image src='turbo_on_button_pm_normal' />
            </Sprite>
            <Sprite>
                <Image src='turbo_on_button_pm_normal' />
            </Sprite>
            <Sprite>
                <Image src='turbo_on_button_pm_pressed' />
            </Sprite>
            <Sprite>
                <Image src='turbo_on_button_pm_disabled' />
            </Sprite>
        </Button>
        <Button position={[1573, 2893]} hitArea={{ width: 325, x: 14, y: 12, type: 'rectangle', height: 196 }} name='turboButtonOff'>
            <Sprite>
                <Image src='turbo_off_button_pm_normal' />
            </Sprite>
            <Sprite>
                <Image src='turbo_off_button_pm_normal' />
            </Sprite>
            <Sprite>
                <Image src='turbo_off_button_pm_pressed' />
            </Sprite>
            <Sprite>
                <Image src='turbo_off_button_pm_disabled' />
            </Sprite>
        </Button>
        <Button position={[807, 2731]} hitArea={{ x: 258, y: 272, type: 'circle', radius: 259 }} name='spinButton'>
            <Sprite>
                <Image src='spin_button_pm_normal' />
                <Image src='hold_for_settings_normal' />
                <Image src='hold_for_settings_normal_en' />
            </Sprite>
            <Sprite>
                <Image src='spin_button_pm_normal' />
                <Image src='hold_for_settings_normal' />
                <Image src='hold_for_settings_normal_en' />
            </Sprite>
            <Sprite>
                <Image src='spin_button_pm_pressed' />
                <Image src='hold_for_settings_pressed' />
                <Image src='hold_for_settings_pressed_en' />
            </Sprite>
            <Sprite>
                <Image src='spin_button_pm_disabled' />
                <Image src='hold_for_settings_disabled' />
                <Image src='hold_for_settings_disabled_en' />
            </Sprite>
        </Button>
        <Button position={[807, 2731]} hitArea={{ x: 258, y: 272, type: 'circle', radius: 259 }} name='spinButtonWithoutHoldSettings'>
            <Sprite>
                <Image src='spin_button_pm_normal' />
                <Image src='hold_for_settings_normal' />
            </Sprite>
            <Sprite>
                <Image src='spin_button_pm_normal' />
                <Image src='hold_for_settings_normal' />
            </Sprite>
            <Sprite>
                <Image src='spin_button_pm_pressed' />
                <Image src='hold_for_settings_pressed' />
            </Sprite>
            <Sprite>
                <Image src='spin_button_pm_disabled' />
                <Image src='hold_for_settings_disabled' />
            </Sprite>
        </Button>
        <Button position={[807, 2731]} hitArea={{ x: 258, y: 272, type: 'circle', radius: 259 }} name='stopAutoplayButton'>
            <Sprite>
                <Image src='stop_button_normal' />
                <Image src='stop_autoplay_normal_en' />
                <Text
                    position={[178, 216]}
                    style={{ fontFamily: 'PF DinDisplay Pro', fontSize: 110, fontWeight: 'bold', fill: '#2A2A2A', align: 'center' }}
                    maxWidth={200}
                    name='spinsAmountField'
                    text='500'
                />
            </Sprite>
            <Sprite>
                <Image src='stop_button_normal' />
                <Image src='stop_autoplay_normal_en' />
                <Text
                    position={[178, 216]}
                    style={{ fontFamily: 'PF DinDisplay Pro', fontSize: 110, fontWeight: 'bold', fill: '#2A2A2A', align: 'center' }}
                    maxWidth={200}
                    name='spinsAmountField'
                    text='500'
                />
            </Sprite>
            <Sprite>
                <Image src='stop_button_pressed' />
                <Image src='stop_autoplay_pressed_en' />
                <Text
                    position={[178, 221]}
                    style={{ fontFamily: 'PF DinDisplay Pro', fontSize: 100, fontWeight: 'bold', fill: '#2A2A2A', align: 'center' }}
                    maxWidth={200}
                    name='spinsAmountField'
                    text='500'
                />
            </Sprite>
            <Sprite>
                <Image src='stop_button_disabled' />
                <Image src='stop_autoplay_disabled_en' />
                <Text
                    position={[178, 212]}
                    style={{ fontFamily: 'PF DinDisplay Pro', fontSize: 110, fontWeight: 'bold', fill: '#2A2A2A', align: 'center' }}
                    maxWidth={200}
                    name='spinsAmountField'
                    text='500'
                />
            </Sprite>
        </Button>
        <Button position={[807, 2731]} hitArea={{ x: 258, y: 272, type: 'circle', radius: 259 }} name='spinsLeftButton'>
            <Sprite>
                <Image src='spin_button_pm_normal' />
                <Image src='spins_left_normal_en' />
                <Text
                    position={[99, 70]}
                    style={{ fontFamily: 'PF DinDisplay Pro', fontSize: 250, fontWeight: 'bold', fill: '#FFFFFF', align: 'center' }}
                    maxWidth={340}
                    name='txt'
                    text='20'
                />
            </Sprite>
            <Sprite>
                <Image src='spin_button_pm_normal' />
                <Image src='spins_left_normal_en' />
                <Text
                    position={[99, 70]}
                    style={{ fontFamily: 'PF DinDisplay Pro', fontSize: 250, fontWeight: 'bold', fill: '#FFFFFF', align: 'center' }}
                    maxWidth={340}
                    name='txt'
                    text='20'
                />
            </Sprite>
            <Sprite>
                <Image src='spin_button_pm_pressed' />
                <Image src='spins_left_pressed_en' />
                <Text
                    position={[99, 91]}
                    style={{ fontFamily: 'PF DinDisplay Pro', fontSize: 220, fontWeight: 'bold', fill: '#FFFFFF', align: 'center' }}
                    maxWidth={340}
                    name='txt'
                    text='20'
                />
            </Sprite>
            <Sprite>
                <Image src='spin_button_pm_disabled' />
                <Image src='spins_left_disabled_en' />
                <Text
                    position={[99, 70]}
                    style={{ fontFamily: 'PF DinDisplay Pro', fontSize: 250, fontWeight: 'bold', fill: '#CACACA', align: 'center' }}
                    maxWidth={340}
                    name='txt'
                    text='20'
                />
            </Sprite>
        </Button>
    </Sprite>
);
